/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from "./core/BaseHttpRequest";
import type { OpenAPIConfig } from "./core/OpenAPI";
import { AxiosHttpRequest } from "./core/AxiosHttpRequest";
import { CommerceAppService } from "./services/CommerceAppService";
import { CommerceAdminAppService } from "./services/CommerceAdminAppService";
import { CredentialsAppService } from "./services/CredentialsAppService";
import { DesignConfigurationAppService } from "./services/DesignConfigurationAppService";
import { DesignRequestAppService } from "./services/DesignRequestAppService";
import { IntegrationAppService } from "./services/IntegrationAppService";
import { JambonzWebhookAppService } from "./services/JambonzWebhookAppService";
import { LeadsAppService } from "./services/LeadsAppService";
import { MetaAdsetsAppService } from "./services/MetaAdsetsAppService";
import { OperationalContactFilesAppService } from "./services/OperationalContactFilesAppService";
import { OperationalContactLinksAppService } from "./services/OperationalContactLinksAppService";
import { OperationalContactPhonesAppService } from "./services/OperationalContactPhonesAppService";
import { OperationalContactsAppService } from "./services/OperationalContactsAppService";
import { OperationalDesignAppService } from "./services/OperationalDesignAppService";
import { OperationalFileTypesAppService } from "./services/OperationalFileTypesAppService";
import { OperationalLinkTypesAppService } from "./services/OperationalLinkTypesAppService";
import { OperationalOrganizationFilesAppService } from "./services/OperationalOrganizationFilesAppService";
import { OperationalOrganizationLinksAppService } from "./services/OperationalOrganizationLinksAppService";
import { OperationalOrganizationsAppService } from "./services/OperationalOrganizationsAppService";
import { OperationalOrganizationTimelineAppService } from "./services/OperationalOrganizationTimelineAppService";
import { OperationalPhoneTypesAppService } from "./services/OperationalPhoneTypesAppService";
import { OperationalWorkspaceOrganizationsAppService } from "./services/OperationalWorkspaceOrganizationsAppService";
import { PaidTrafficAppService } from "./services/PaidTrafficAppService";
import { PerfilClickAppService } from "./services/PerfilClickAppService";
import { PerfilClicksAppService } from "./services/PerfilClicksAppService";
import { PermissionsAppService } from "./services/PermissionsAppService";
import { ProductPlansAppService } from "./services/ProductPlansAppService";
import { ProfessionsAppService } from "./services/ProfessionsAppService";
import { PublicAppService } from "./services/PublicAppService";
import { RoleAppService } from "./services/RoleAppService";
import { SalesKanbanAppService } from "./services/SalesKanbanAppService";
import { SegmentsAppService } from "./services/SegmentsAppService";
import { SelfServiceEnrollmentsAppService } from "./services/SelfServiceEnrollmentsAppService";
import { SessionAppService } from "./services/SessionAppService";
import { SocialMediaAutomationAppService } from "./services/SocialMediaAutomationAppService";
import { StaffAppService } from "./services/StaffAppService";
import { StaffDesignPublicationsAppService } from "./services/StaffDesignPublicationsAppService";
import { StageAppService } from "./services/StageAppService";
import { TagAppService } from "./services/TagAppService";
import { TeamMilestoneAppService } from "./services/TeamMilestoneAppService";
import { TelecomAppService } from "./services/TelecomAppService";
import { TokenAuthAppService } from "./services/TokenAuthAppService";
import { UserAppService } from "./services/UserAppService";
import { WorkspaceInvitesAppServiceAppService } from "./services/WorkspaceInvitesAppServiceAppService";
import { WorkspaceMembersAppServiceAppService } from "./services/WorkspaceMembersAppServiceAppService";
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class SyncClient {
  public readonly commerce: CommerceAppService;
  public readonly commerceAdmin: CommerceAdminAppService;
  public readonly credentials: CredentialsAppService;
  public readonly designConfiguration: DesignConfigurationAppService;
  public readonly designRequest: DesignRequestAppService;
  public readonly integration: IntegrationAppService;
  public readonly jambonzWebhook: JambonzWebhookAppService;
  public readonly leads: LeadsAppService;
  public readonly metaAdsets: MetaAdsetsAppService;
  public readonly operationalContactFiles: OperationalContactFilesAppService;
  public readonly operationalContactLinks: OperationalContactLinksAppService;
  public readonly operationalContactPhones: OperationalContactPhonesAppService;
  public readonly operationalContacts: OperationalContactsAppService;
  public readonly operationalDesign: OperationalDesignAppService;
  public readonly operationalFileTypes: OperationalFileTypesAppService;
  public readonly operationalLinkTypes: OperationalLinkTypesAppService;
  public readonly operationalOrganizationFiles: OperationalOrganizationFilesAppService;
  public readonly operationalOrganizationLinks: OperationalOrganizationLinksAppService;
  public readonly operationalOrganizations: OperationalOrganizationsAppService;
  public readonly operationalOrganizationTimeline: OperationalOrganizationTimelineAppService;
  public readonly operationalPhoneTypes: OperationalPhoneTypesAppService;
  public readonly operationalWorkspaceOrganizations: OperationalWorkspaceOrganizationsAppService;
  public readonly paidTraffic: PaidTrafficAppService;
  public readonly perfilClick: PerfilClickAppService;
  public readonly perfilClicks: PerfilClicksAppService;
  public readonly permissions: PermissionsAppService;
  public readonly productPlans: ProductPlansAppService;
  public readonly professions: ProfessionsAppService;
  public readonly public: PublicAppService;
  public readonly role: RoleAppService;
  public readonly salesKanban: SalesKanbanAppService;
  public readonly segments: SegmentsAppService;
  public readonly selfServiceEnrollments: SelfServiceEnrollmentsAppService;
  public readonly session: SessionAppService;
  public readonly socialMediaAutomation: SocialMediaAutomationAppService;
  public readonly staff: StaffAppService;
  public readonly staffDesignPublications: StaffDesignPublicationsAppService;
  public readonly stage: StageAppService;
  public readonly tag: TagAppService;
  public readonly teamMilestone: TeamMilestoneAppService;
  public readonly telecom: TelecomAppService;
  public readonly tokenAuth: TokenAuthAppService;
  public readonly user: UserAppService;
  public readonly workspaceInvitesAppService: WorkspaceInvitesAppServiceAppService;
  public readonly workspaceMembersAppService: WorkspaceMembersAppServiceAppService;
  public readonly request: BaseHttpRequest;
  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest,
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? "",
      VERSION: config?.VERSION ?? "frontend/v1",
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? "include",
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.commerce = new CommerceAppService(this.request);
    this.commerceAdmin = new CommerceAdminAppService(this.request);
    this.credentials = new CredentialsAppService(this.request);
    this.designConfiguration = new DesignConfigurationAppService(this.request);
    this.designRequest = new DesignRequestAppService(this.request);
    this.integration = new IntegrationAppService(this.request);
    this.jambonzWebhook = new JambonzWebhookAppService(this.request);
    this.leads = new LeadsAppService(this.request);
    this.metaAdsets = new MetaAdsetsAppService(this.request);
    this.operationalContactFiles = new OperationalContactFilesAppService(
      this.request,
    );
    this.operationalContactLinks = new OperationalContactLinksAppService(
      this.request,
    );
    this.operationalContactPhones = new OperationalContactPhonesAppService(
      this.request,
    );
    this.operationalContacts = new OperationalContactsAppService(this.request);
    this.operationalDesign = new OperationalDesignAppService(this.request);
    this.operationalFileTypes = new OperationalFileTypesAppService(
      this.request,
    );
    this.operationalLinkTypes = new OperationalLinkTypesAppService(
      this.request,
    );
    this.operationalOrganizationFiles =
      new OperationalOrganizationFilesAppService(this.request);
    this.operationalOrganizationLinks =
      new OperationalOrganizationLinksAppService(this.request);
    this.operationalOrganizations = new OperationalOrganizationsAppService(
      this.request,
    );
    this.operationalOrganizationTimeline =
      new OperationalOrganizationTimelineAppService(this.request);
    this.operationalPhoneTypes = new OperationalPhoneTypesAppService(
      this.request,
    );
    this.operationalWorkspaceOrganizations =
      new OperationalWorkspaceOrganizationsAppService(this.request);
    this.paidTraffic = new PaidTrafficAppService(this.request);
    this.perfilClick = new PerfilClickAppService(this.request);
    this.perfilClicks = new PerfilClicksAppService(this.request);
    this.permissions = new PermissionsAppService(this.request);
    this.productPlans = new ProductPlansAppService(this.request);
    this.professions = new ProfessionsAppService(this.request);
    this.public = new PublicAppService(this.request);
    this.role = new RoleAppService(this.request);
    this.salesKanban = new SalesKanbanAppService(this.request);
    this.segments = new SegmentsAppService(this.request);
    this.selfServiceEnrollments = new SelfServiceEnrollmentsAppService(
      this.request,
    );
    this.session = new SessionAppService(this.request);
    this.socialMediaAutomation = new SocialMediaAutomationAppService(
      this.request,
    );
    this.staff = new StaffAppService(this.request);
    this.staffDesignPublications = new StaffDesignPublicationsAppService(
      this.request,
    );
    this.stage = new StageAppService(this.request);
    this.tag = new TagAppService(this.request);
    this.teamMilestone = new TeamMilestoneAppService(this.request);
    this.telecom = new TelecomAppService(this.request);
    this.tokenAuth = new TokenAuthAppService(this.request);
    this.user = new UserAppService(this.request);
    this.workspaceInvitesAppService = new WorkspaceInvitesAppServiceAppService(
      this.request,
    );
    this.workspaceMembersAppService = new WorkspaceMembersAppServiceAppService(
      this.request,
    );
  }
}
